import { TransactionType } from '@nemuru-eng/js-api-client';

export const ALLOWED_TRANSACTION_TYPES_FOR_MULTI_SELECT_FILTER = [
  TransactionType.SALE,
  TransactionType.REFUND,
  TransactionType.FIXED_FEE,
  TransactionType.VARIABLE_FEE,
  TransactionType.COST_OF_CREDIT,
  TransactionType.DEBT_BALANCE,
  TransactionType.FEE_CORRECTION,
  TransactionType.OTHER,
];

export const TRANSACTION_TYPES_DEFINITIONS = {
  [TransactionType.SALE]: {
    iconName: 'shopping_cart',
    SECTION_T_ID: TransactionType.SALE,
  },
  [TransactionType.FIXED_FEE]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.FIXED_FEE,
  },
  [TransactionType.VARIABLE_FEE]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.VARIABLE_FEE,
  },
  [TransactionType.REFUND]: {
    iconName: 'undo',
    SECTION_T_ID: TransactionType.REFUND,
  },
  [TransactionType.REFUND_FEE]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.REFUND_FEE,
  },
  [TransactionType.DEBT_BALANCE]: {
    iconName: 'sync_alt',
    SECTION_T_ID: TransactionType.DEBT_BALANCE,
  },
  [TransactionType.COST_OF_CREDIT]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.COST_OF_CREDIT,
  },
  [TransactionType.FEE_CORRECTION]: {
    iconName: 'sync_alt',
    SECTION_T_ID: TransactionType.FEE_CORRECTION,
  },
  [TransactionType.CORRECTION]: {
    iconName: 'sync_alt',
    SECTION_T_ID: TransactionType.CORRECTION,
  },
  [TransactionType.REVERSAL]: {
    iconName: 'sync_alt',
    SECTION_T_ID: TransactionType.REVERSAL,
  },
  [TransactionType.HOLDBACK]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.HOLDBACK,
  },
  [TransactionType.WITHHOLDING]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.WITHHOLDING,
  },
  [TransactionType.RELEASE]: {
    iconName: 'shopping_cart',
    SECTION_T_ID: TransactionType.RELEASE,
  },
  [TransactionType.OTHER]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.OTHER,
  },
  [TransactionType.FEE]: {
    iconName: 'toll',
    SECTION_T_ID: TransactionType.FEE,
  },
};
